import React from 'react'
import { FormattedMessage } from 'react-intl'

type BestPlanInfoProps = {
  selected?: boolean
}

export default function BestPlanInfo({ selected = true }: BestPlanInfoProps) {
  return (
    <div className="text-center">
      <span
        className={`
        z-20 whitespace-nowrap
        rounded-20 px-12
        ${
          selected
            ? 'bg-green-electric py-6 lg:py-8'
            : 'bg-beige-muted py-4 lg:py-6'
        }
        text-black type-14-demibold lg:px-16
      `}
      >
        <span className="relative">
          <FormattedMessage
            defaultMessage="Most popular"
            id="chooseSubscription.mostPopular"
          />
        </span>
      </span>
    </div>
  )
}
